export const TRIGGER_TABLE_HEADERS = [
    { key: 'triggerDate', label: 'Trigger Date' },
    { key: 'npi', label: 'NPI' },
    { key: 'name', label: 'Name' },
    { key: 'location', label: 'Location' },
    { key: 'district', label: 'Region - RMD' },
    { key: 'territory', label: 'Territory-IROC' },
    { key: 'samTerritory', label: 'Territory - SAM' },
    { key: 'segment', label: 'Physician Segment' },
    { key: 'specialty', label: 'Physician Specialty' },
    { key: 'digital_engagement_priority', label: 'Digital Engagement' },
    { key: 'suggest_fmt_trigger', label: 'FMT Match' },
    { key: 'fieldEngagement', label: 'Field Engagement' },
];

export const TRIGGER_TABLE_HEADERS_WITHOUT_PHYSICIAN = [
    { key: 'triggerDate', label: 'Trigger Date' },
    { key: 'npi', label: 'NPI' },
    { key: 'name', label: 'Name' },
    { key: 'location', label: 'Location' },
    { key: 'district', label: 'Region - RMD' },
    { key: 'territory', label: 'Territory-IROC' },
    { key: 'samTerritory', label: 'Territory - SAM' },
    { key: 'segment', label: 'Segment' },
    { key: 'specialty', label: 'Specialty' },
    { key: 'digital_engagement_priority', label: 'Digital Engagement' },
    { key: 'suggest_fmt_trigger', label: 'FMT Match' },
    { key: 'fieldEngagement', label: 'Field Engagement' },
];
